/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

class GlobalErrorBoundaryClass extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    navigate: PropTypes.func.isRequired,
  };

  componentDidCatch() {
    if (process.env.NODE_ENV === 'production') this.props.navigate('/');
  }

  render() {
    return this.props.children;
  }
}

// Wrapper to provide navigate function from hooks
function GlobalErrorBoundary({ children }) {
  const navigate = useNavigate();
  return <GlobalErrorBoundaryClass navigate={navigate}>{children}</GlobalErrorBoundaryClass>;
}

export default GlobalErrorBoundary;
